import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import Reveal from "@/components/Reveal";

const SCOPES = [
  "Smart Township Development",
  "Private Luxury Residence / Villa",
  "Hotel & Commercial Office Automation",
  "AIoT Hardware Bulk Procurement",
];

export default function EnquiryForm() {
  const [form, setForm] = useState({ name: "", phone: "", scope: SCOPES[0] });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/enquiries", form);
      toast.success("Enquiry submitted", {
        description: "Our engineering team will call you back within 24 hours.",
      });
      setForm({ name: "", phone: "", scope: SCOPES[0] });
    } catch (err) {
      toast.error("Could not submit enquiry", {
        description: err?.response?.data?.detail || "Please check your details and try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  const fieldCls =
    "w-full bg-[#061536] border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-[#00F0FF] text-sm";

  return (
    <section id="enquiry" className="py-24 px-6 border-t border-[#00F0FF]/20 bg-[#030A1C] scroll-mt-20" data-testid="enquiry-section">
      <div className="max-w-4xl mx-auto">
        <Reveal>
        <div className="text-center mb-12">
          <span className="font-mono-lbl text-xs text-[#00F0FF] uppercase tracking-widest block mb-2">Request Consultation</span>
          <h2 className="font-disp text-4xl sm:text-5xl uppercase tracking-tight mb-4">Engineer Your Space</h2>
          <p className="text-white/70 text-sm">Tell us about your home, hotel or township project. Our engineering team calls you back within 24 hours.</p>
        </div>
        </Reveal>

        <form className="space-y-6 max-w-xl mx-auto" onSubmit={submit} data-testid="enquiry-form">
          <div>
            <label className="block font-mono-lbl text-xs uppercase text-white/70 mb-2" htmlFor="enquiry-name">Full Name</label>
            <input
              id="enquiry-name"
              type="text"
              required
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="e.g. Vikramaditya Sharma"
              className={fieldCls}
              data-testid="enquiry-name-input"
            />
          </div>
          <div>
            <label className="block font-mono-lbl text-xs uppercase text-white/70 mb-2" htmlFor="enquiry-phone">Phone Number</label>
            <input
              id="enquiry-phone"
              type="tel"
              required
              value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
              placeholder="+91 98765 43210"
              className={fieldCls}
              data-testid="enquiry-phone-input"
            />
          </div>
          <div>
            <label className="block font-mono-lbl text-xs uppercase text-white/70 mb-2" htmlFor="enquiry-scope">Project Scope</label>
            <select
              id="enquiry-scope"
              value={form.scope}
              onChange={(e) => setForm({ ...form, scope: e.target.value })}
              className={fieldCls}
              data-testid="enquiry-scope-select"
            >
              {SCOPES.map((s) => (
                <option key={s}>{s}</option>
              ))}
            </select>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#FF2E2E] hover:bg-[#E01F1F] disabled:opacity-60 text-white py-4 rounded-lg font-mono-lbl text-xs uppercase tracking-wider font-bold shadow-lg shadow-black/30 transition-colors"
            data-testid="enquiry-submit-btn"
          >
            {loading ? "Submitting..." : "Submit Project Enquiry"}
          </button>
        </form>
      </div>
    </section>
  );
}
